import { useEffect, useMemo } from 'react';
import MessagesPlugin from '../models/messages';

/**
 * L'hook si registra a FwPlugins e usa l'oggetto/funzione reducer prodotto
 * da reducerCreator per gestire gli eventi.
 *
 * Se reducerCreator produce un oggetto, esegue `reducer[type](payload)`,
 * se reducerCreator produce una funzione, esegue `reducer(type,payload)`,
 * @param {func} reducerCreator funzione senza parametri che genera l'oggetto reducer
 * @param {array} dependencies dipendenze della funzione. Sono utilizzare per
 * memorizzare il risultato di reducerCreator.
 */
const usePluginReducer = (reducerCreator, dependencies) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const reducer = useMemo(reducerCreator, dependencies);
  useEffect(() => {
    const handler = ({ type, payload }) => {
      if (typeof reducer === 'object') {
        const callback = reducer[type];
        callback && callback(payload);
      } else if (typeof reducer === 'function') {
        reducer(type, payload);
      }
    };
    MessagesPlugin.subscribe(handler);
    return () => MessagesPlugin.unsubscribe(handler);
  }, [reducer]);
};

export default usePluginReducer;
